module.exports = __webpack_public_path__ + "static/Group 7211-734acc2c78aa6b3e88490e02303a7c6b.png";